import { useState } from "react";
import Column from "@amzn/meridian/esm/components/column";
import Expander from "@amzn/meridian/esm/components/expander";
import Icon from "@amzn/meridian/esm/components/icon";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import userTokens from "@amzn/meridian-tokens/base/icon/user";
import { THEME_COLOR } from "../../styles/colors";

const MentionCard = ({ name, time, context, detail }) => {
  const [open, setOpen] = useState();

  const userAvatar = (
    <div style={{
      width: 28,
      height: 28,
      borderRadius: "50%",
      backgroundColor: THEME_COLOR.MINT_GREEN,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    }}>
      <div style={{ transform: "scale(0.60)" }}>
        <Theme tokens={{ iconColorSecondary: THEME_COLOR.SEAFOAM_GREEN }}>
          <Icon tokens={userTokens} color="secondary" />
        </Theme>
      </div>
    </div>
  );

  const title = (
    <Row spacing="300" alignmentVertical="top">
      {userAvatar}
      <Column spacing="100">
        <Row spacing="200" alignmentVertical="center">
          <Text type="h50">{name || "Your name was mentioned"}</Text>
          {/* {time && <Text type="b200" color="secondary">{time}</Text>} */}
        </Row>
        <Text type="b200">
          {context}
        </Text>
      </Column>
    </Row>
  );

  return (
    <Theme tokens={{ expanderBorderColor: THEME_COLOR.MIST_GRAY, expanderBorderRadiusBox: 8, expanderSpacingHorizontal: 8, expanderForegroundColorAccentDefault: THEME_COLOR.MID_GRAY }}>
      <div className="mention-card-expander">
        <Expander title={title} open={open} onChange={setOpen} type="box">
          <div style={{ marginLeft: -36 }}>
            <Text type="b200">
              {detail}
            </Text>
          </div>
        </Expander>
      </div>
    </Theme>
  );
};

export default MentionCard;
